export const DISCOUNT_DISCLAIMER_BOLD = 'Discount Applied!';
export const DISCOUNT_DISCLAIMER_REGULAR =
  'Your first regular-sized bag is FREE. Recurring order price or additional regular bags $11.99 each.';
export const DISCOUNT_DISCLAIMER_CTA = 'See Terms';
